import React, { PureComponent } from 'react';
import Proptypes from 'prop-types';
import styles from './index.css';

class Banner extends PureComponent {
    static propTypes = {
        type: Proptypes.oneOf(['small', 'large', 'car']),
        title: Proptypes.string,
        style: Proptypes.object
    }

    render() {
        const { type, title, style } = this.props;

        return (
            <div className={`${styles.banner} ${styles[type]}`} style={style}>{title}</div>
        );
    }
}

export default Banner;
